import { createSelector } from 'reselect';
import { getState } from './state';
export const getActivitySlice = createSelector([
    getState
], (slice)=>{
    return slice.activity;
});
export const getActivityRoomQueue = createSelector(getActivitySlice, (state)=>{
    return state === null || state === void 0 ? void 0 : state.roomsQueue;
});

//# sourceMappingURL=global.js.map